import React from "react";
import { IconSize, IconProps } from "../theme";

const TrendingUp: React.FC<IconProps> = ({ size = IconSize.M }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Vector"
        d="M28.0006 1V9C28.0007 9.1979 27.9421 9.39139 27.8323 9.55598C27.7224 9.72058 27.5662 9.84887 27.3833 9.92462C27.2005 10.0004 26.9993 10.0202 26.8053 9.98153C26.6112 9.94288 26.4329 9.84751 26.2931 9.7075L23.0006 6.41375L15.7081 13.7075C15.6152 13.8005 15.5049 13.8742 15.3835 13.9246C15.2621 13.9749 15.132 14.0008 15.0006 14.0008C14.8691 14.0008 14.739 13.9749 14.6176 13.9246C14.4962 13.8742 14.3859 13.8005 14.2931 13.7075L10.0006 9.41375L1.70806 17.7075C1.52042 17.8951 1.26592 18.0006 1.00056 18.0006C0.735192 18.0006 0.480697 17.8951 0.293056 17.7075C0.105415 17.5199 0 17.2654 0 17C0 16.7346 0.105415 16.4801 0.293056 16.2925L9.29306 7.2925C9.38593 7.19952 9.49622 7.12577 9.61762 7.07544C9.73901 7.02512 9.86914 6.99921 10.0006 6.99921C10.132 6.99921 10.2621 7.02512 10.3835 7.07544C10.5049 7.12577 10.6152 7.19952 10.7081 7.2925L15.0006 11.5863L21.5868 5L18.2931 1.7075C18.153 1.56764 18.0577 1.38939 18.019 1.19531C17.9804 1.00122 18.0002 0.800033 18.0759 0.61721C18.1517 0.434387 18.28 0.278151 18.4446 0.16828C18.6092 0.0584092 18.8027 -0.000155428 19.0006 3.09801e-07H27.0006C27.2658 3.09801e-07 27.5201 0.105357 27.7077 0.292894C27.8952 0.48043 28.0006 0.734784 28.0006 1Z"
        fill="#071443"
      />
    </svg>
  );
};

export default TrendingUp;
